export const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue'),
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: () => import('@/views/AuthCallback.vue'),
  },
  {
    path: '/invite/:token',
    name: 'InviteAccept',
    component: () => import('@/views/InviteAccept.vue'),
  },
  {
    path: '/dashboard',
    component: () => import('@/views/dashboard/DashboardLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/dashboard/public-environments',
      },
      {
        path: 'environments',
        name: 'Environments',
        component: () => import('@/views/dashboard/Environments.vue'),
      },
      {
        path: 'environments/:id',
        name: 'EnvironmentDetail',
        component: () => import('@/views/dashboard/EnvironmentDetail.vue'),
      },
      {
        path: 'teams',
        name: 'Teams',
        component: () => import('@/views/dashboard/Teams.vue'),
      },
      {
        path: 'public-environments',
        name: 'PublicEnvironments',
        component: () => import('@/views/dashboard/PublicEnvironments.vue'),
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('@/views/dashboard/Notifications.vue'),
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/dashboard/Profile.vue'),
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('@/views/dashboard/ChangePassword.vue'),
      },
    ],
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
  },
]
